import regions from "./regions.json" with { type: "json" };

const polygons = regions.flatMap(({ country, region, geometry }) => (geometry.type === "Polygon" ? [geometry.coordinates] : geometry.coordinates).map((coordinates) => ({
  country, region, coordinates,
  extent: coordinates[0].reduce((extent, coordinate) => [Math.min(extent[0], coordinate[0]), Math.min(extent[1], coordinate[1]), Math.max(extent[2], coordinate[0]), Math.max(extent[3], coordinate[1])], [Infinity, Infinity, -Infinity, -Infinity]),
})));

const inRing = (coordinate, ring) => {
  let inside = false;
  for (let index = 0, previous = ring.length - 1; index < ring.length; previous = index++) {
    const [x, y] = ring[index];
    const [previousX, previousY] = ring[previous];
    if ((y > coordinate[1]) !== (previousY > coordinate[1]) && coordinate[0] < (previousX - x) * (coordinate[1] - y) / (previousY - y) + x) inside = !inside;
  }
  return inside;
};

const cache = new Map();
export const photoRegion = (image) => {
  const coordinate = image.location?.coordinate;
  let region;
  if (coordinate) {
    const key = coordinate.join(",");
    if (!cache.has(key)) {
      const polygon = polygons.find(({ extent, coordinates }) => coordinate[0] >= extent[0] && coordinate[0] <= extent[2] && coordinate[1] >= extent[1] && coordinate[1] <= extent[3] && inRing(coordinate, coordinates[0]) && !coordinates.slice(1).some((ring) => inRing(coordinate, ring)));
      cache.set(key, polygon ? { country: polygon.country, region: polygon.region } : undefined);
    }
    region = cache.get(key);
  }
  return region || { country: image.country || "", region: image.region || "" };
};

export const matchesPhotoRegion = (image, country, region) => {
  const photo = photoRegion(image);
  return (!country || photo.country === country) && (!region || photo.region === region);
};
